import React from 'react'
import AuditPane from '../AuditPane'
import AuditSidebar from '../AuditSidebar'
import AuditExpanded from '../AuditExpanded'
import AuditModal from '../AuditModal'
import BambooBanner from '../BambooBanner'

const AuditLanding = props => {
  return (
    <div className="audit-divs audit">
      <div className="audit-container">
        <BambooBanner bannerType={'auditBanner'} />
        <AuditModal />
        <AuditPane id={props.match.params.id} />
        <AuditSidebar />
        <AuditExpanded itemId={props.match.params.itemId} id={props.match.params.id} />
      </div>
    </div>
  )
}

export default AuditLanding
